import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { TransactionStatus } from '../../reports/reports.model';
import { OpenInvoiceItem } from '../../shared/models/make-payment.model';
import { CurrencyPipe } from '@angular/common';
import { I18nModule } from '@spartacus/core';
import { PaymentMethodComponent } from '../../shared/components/payment-method/payment-method.component';
import { MakeAPaymentService } from '../make-a-payment.service';
import { CommonUtils } from '../../shared/utils/common.utils';
import { EU_DATE_FORMAT, US_DATE_FORMAT } from '../../shared/config/app.config';

@Component({
  selector: 'sanofi-payments-confirmation-invoices-list-row',
  imports: [
    CurrencyPipe,
    I18nModule,
    PaymentMethodComponent
  ],
  templateUrl: './payments-confirmation-invoices-list-row.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentsConfirmationInvoicesListRowComponent {
  private readonly makeAPayment = inject(MakeAPaymentService);

  status = input.required<TransactionStatus>();
  id = input.required<string>();
  date = input.required<string>();
  invoiceItemForPaymentMethod = input<OpenInvoiceItem>(null);
  amount = input.required<string>();
  protected readonly CommonUtils = CommonUtils;
  protected readonly US_DATE_FORMAT = US_DATE_FORMAT;
  protected readonly EU_DATE_FORMAT = EU_DATE_FORMAT;

  invoicePdf(invoiceNo: string): void {
    this.makeAPayment.downloadPdf(invoiceNo);
  }
}
